
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|4606|7458|7992)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
